import { render, staticRenderFns } from "./ProductionOrderPreview.vue?vue&type=template&id=2e145f92&scoped=true&"
import script from "./ProductionOrderPreview.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOrderPreview.vue?vue&type=style&index=0&id=2e145f92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e145f92",
  null
  
)

export default component.exports